import("../src/javascripts/navigation");
import("../src/javascripts/slider_splide");
import("../src/javascripts/easy-toggle");

// script for form attachment inputs in contact form
import("../src/javascripts/attachments-redesign");
import("../src/javascripts/smooth-scroll-to-anchor");
